import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { BuilderSections } from '../../util/builder';
import { Currency } from '../../types/apollo/generated/types.generated';

const rixolondonSizes = [
  'XXS/UK6',
  'XS/UK8',
  'S/UK10',
  'L/UK14',
  'M/UK12',
  'XL/UK16',
  '2XL/UK18',
  '3XL/UK20',
  '4XL/UK22',
  '5XL/UK24',
  '6XL/UK26',
  'ONE-SIZE',
  'UK3/EU36',
  'UK4/EU37',
  'UK5/EU38',
  'UK6/EU39',
  'UK7/EU40',
  'UK8/EU41',
  'UK9/EU42',
];

export const rixolondonShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({ sizes: rixolondonSizes }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: '825c4ec3df934d00ba324542684d8639',
      [BuilderSections.AboutPageHeroContent]: 'f4ce8e06452447f09556edeaffa407d9',
      [BuilderSections.AboutPageNavbarContent]: 'e8bfca5b14ed4ea4840adc653bf64f8c',
      [BuilderSections.AboutPageInfoTabContent]: '7d07c518f38243eca8c3f5fc64e7e878',
      [BuilderSections.ListingPageTitleAndVariantDetailsContent]:
        'e6146464aa1f4f1299410b44da789c49',
      [BuilderSections.ListingCardDetails]: '7375f5fa8cbf41f4a09a9772cd7eb213',
    },
  },
  returnShippingPrice: {
    price: 300,
    currency: Currency.Gbp,
  },
};
